module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("Subterranean Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("© 2006 Sharon Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("First published in 2006 by Haymarket Books")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("This edition published in 2018 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("PO Box 180165")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("Chicago, IL 60618")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("773-583-7884")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("www.haymarketbooks.org")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("ISBN: 978-1-60846-918-5")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("Cover design by Eric Kerl.")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("This book was published with the generous "), _c('br'), _vm._v("support of the Wallace Global Fund.")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("Library of Congress Cataloging in Publication Data is available")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Text-body ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-4"
  }, [_vm._v("Printed in Canada by union labor.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 63
// module chunks = 0